<template>
<div class="vue-slider-teaser" :class="{'active-vehicle': activeVehicle}" @click="handleClick">
    <div class="image">
        <img
            v-if="hasImage"
            :src="vehicleData.images[0]" :alt="vehicleData.title">
    </div>

    <div class="title-price-wrapper font-weight-bold">
        <p class="mb-0" v-html="`V.a. ` + generatePriceMarkup(prices.per_day)"></p>
        <p class="vehicle-title mb-0 color-text">{{ vehicleData.title }}</p>
    </div>
</div>
</template>

<script>
import CurrencyFormatter from "../../mixins/CurrencyFormatter";

export default {
    name: "SliderTeaser",

    mixins: [CurrencyFormatter],

    props: {
        vehicleData: {
            type: Object,
            required: true,
        },
        activeVehicle: {
            type: Boolean,
            default: false,
        },
        isBusiness: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        hasImage() {
            return !lodash.isEmpty(this.vehicleData.images);
        },

        prices() {
            return {
                per_day: this.calculatePrice(this.vehicleData.price_per_day, drupalSettings.vat_percentage),
                per_weekend: this.calculatePrice(this.vehicleData.price_per_weekend, drupalSettings.vat_percentage),
                per_week: this.calculatePrice(this.vehicleData.price_per_week, drupalSettings.vat_percentage),
                discount_price: this.calculatePrice(this.vehicleData.discount_price, drupalSettings.vat_percentage),
            };
        },
    },

    methods: {
        calculatePrice(price, vatPercentage) {
            return (this.isBusiness === true) ? (price / (1 + (vatPercentage / 100))).toFixed(2) : price;
        },

        generatePriceMarkup(price) {
            if (isNaN(price) || price === null || price === undefined) {
                return price;
            }
            else if (Number.isInteger(price)) {
                return price + ",-";
            }

            const priceParts = price.toString().split(".");
            return `${priceParts[0]},<sup>${priceParts[1]}</sup>`;
        },

        handleClick() {
            this.$emit('vehicle-clicked')
        }
    }
}
</script>

<style scoped>
img {
    pointer-events: none;
}
</style>